// extracted by mini-css-extract-plugin
module.exports = {"m--card":"Card_m--card__EePtH","loading-overlay":"Card_loading-overlay__je72T","card-shadow":"Card_card-shadow__nX38Y"};